export default __webpack_public_path__ + "static/thomas-12e5d44efb840ca5ac59e271cc9e5be9.jpg";